import $ from 'jquery';

import { Formatter } from '@dealersites/dealersite-js-core';
import Swal from 'sweetalert2';
import { oemLocalization } from './translations';

const configurePage = $('#configure-container');
if (configurePage.length !== 0) {
  const bottomBarBtnNext = $('.BottomBarBtnNext a');
  const bottomBarTotal = $('#bottom-bar--total');
  const configureRow = $('.ConfigureRow');
  const provinceCode = configureRow.data('provinceCode');
  const styleId = configureRow.data('styleId');
  const carouselInner = $('.carousel-inner');
  const colorizedImages = carouselInner.data('colorizedImages');
  const interiorImages = carouselInner.data('interiorImages');
  const loadingSpinner = $('.LoadingSpinner');
  const baseURL = '/showroom/_configure';
  let configToken = configurePage.data('configToken');
  let status = '';
  let isFullyConfigured = true;
  let configureTotal = bottomBarTotal.data('total');

  /**
   * Toggles the loading screen on and off depending on
   * the boolean value presented.
   *
   * @param {boolean}        active
   */
  function toggleLoadingScreen(active) {
    if (active) {
      loadingSpinner.show();
      return;
    }

    loadingSpinner.hide();
  }

  function updateTotalPrice(price) {
    if (configureTotal === price) {
      return;
    }

    configureTotal = price;
    bottomBarTotal.text(Formatter.price(price, 2));
    bottomBarTotal.addClass('HighlightTotal');
    setTimeout(function () {
      bottomBarTotal.removeClass('HighlightTotal');
    }, 3000);
  }

  /**
   * Creates an AJAX request to fetch Chrome Data. If Configuration Token is null
   * the request will automatically return one. If both Configuration Token and
   * Option Codes are present, the request will return an object with a new Configuration
   * Token and all the Chrome Data relevant for the current configuration.
   *
   * @param {string|null}        configurationToken
   * @param {string|null}        optionCode
   *
   * @returns {Object}
   */
  function requestChromeData(configurationToken = null, optionCode = null) {
    toggleLoadingScreen(true);

    const styleIdQuery = `?style_id=${styleId}`;
    const configQuery =
      configurationToken === null ? '' : `&configuration_token=${configurationToken}`;
    const optionQuery = configQuery.length > 0 ? `&option_code=${optionCode}` : '';
    const requestURL = `${baseURL}${styleIdQuery}${configQuery}${optionQuery}`;

    $.ajax({
      type: 'GET',
      url: requestURL,
      success: function (res) {
        const configuration = res.data;
        configToken = configuration.configuration_token;
        status = configuration.status;

        if (status === 'UserChoiceNeeded') {
          let inputOptions = {};
          if (configuration.optional_equipment) {
            configuration.optional_equipment.forEach(function (option) {
              inputOptions[option.chrome_option_code] = option.primary_name;
            });

            Swal.fire({
              title: `${oemLocalization.gettext('Please select one of the following options')}: `,
              customClass: {
                container: 'user-choice-alert',
              },
              input: 'radio',
              inputOptions: inputOptions,
              width: '1000',
            }).then((result) => {
              // Infinite loop until user selects an option
              if (!result.value) {
                handleOptionSelection(optionCode);
              }
              handleOptionSelection(result.value);
            });
          }
        } else {
          // No conflict
          if (configuration.optional_equipment) {
            const $alertContent = document.createElement('p');
            $alertContent.classList.add('text-left');
            $alertContent.innerHTML = `${oemLocalization.gettext(
              'Please note the following options have changed',
            )}: <br /><br />`;

            configuration.optional_equipment.forEach((option) => {
              const $optionEl = $(`#${option.chrome_option_code}`);
              const optionWasChecked = $optionEl.hasClass('checked');

              switch (option.selection_state) {
                case 'Selected':
                case 'Included':
                case 'Required':
                  $alertContent.innerHTML += `<i class="fas fa-check text-success"></i> Added: <b>${option.header_name}: ${option.primary_name}</b><br /><br />`;
                  $optionEl.addClass('checked');
                  $optionEl.prop('checked', true);
                  $optionEl.parent('.OptionsAccessoriesInput').removeClass('text-muted');
                  break;
                case 'Unselected':
                case 'Excluded':
                case 'Upgraded':
                  if (optionWasChecked) {
                    $alertContent.innerHTML += `<i class="fas fa-times text-danger"></i> Removed: <b>${option.header_name}: ${option.primary_name}</b><br /><br />`;
                    $optionEl.prop('checked', false);
                    $optionEl.removeClass('checked');
                  }
                  break;
              }

              // Visually indicate to user if the next option they select will be compatible or
              // will change one or more options they've already selected.
              // i.e.
              // 1. User selected 'TWO-Tone Paint' option
              // 2. User should see that if they now select a 'ONE-Tone Colour: Black',
              // this will impact their current configuration e.g. remove 'TWO-Tone Paint'
              if (
                option.selection_state === 'Excluded'
                // || option.selection_state === 'Upgraded'
              ) {
                $optionEl.parent('.OptionsAccessoriesInput').addClass('text-muted');
              } else {
                $optionEl.parent('.OptionsAccessoriesInput').removeClass('text-muted');
              }
            });

            Swal.fire({
              html: $alertContent,
              showCloseButton: true,
              showConfirmButton: false,
              width: '1000',
            });
          }
        }

        isFullyConfigured = configuration.fully_configured;
        updateTotalPrice(configuration.total_msrp);
        updateNextButton(configuration.configuration_token);
        toggleLoadingScreen(false);
      },
      error: function () {
        toggleLoadingScreen(false);
        Swal.fire({
          title: oemLocalization.gettext('Oops...'),
          text: oemLocalization.gettext(
            'It seems that something went wrong, please try again later!',
          ),
          icon: 'error',
          showCloseButton: true,
          showConfirmButton: false,
        });
      },
      dataType: 'json',
    });
  }

  /**
   * Erases all slides in the configuration page.
   */
  function eraseAllSlide() {
    $('.carousel-item').remove();
  }

  /**
   * Takes in an array of images to create new slides from Chrome Data.
   *
   * @param {array}        imageUrlList
   */
  function createSlides(imageUrlList) {
    imageUrlList.forEach((imageUrl, index) => {
      let carouselItemId = imageUrl.split('/');
      carouselItemId = carouselItemId[carouselItemId.length - 1].split('.')[0];

      const carouselItem = $('<div></div>')
        .addClass('carousel-item')
        .attr('data-toggle', 'modal')
        .attr('href', `#${carouselItemId}`);

      const carouselImage = $('<img />')
        .addClass('carousel-item--image d-block w-100')
        .attr('src', `${imageUrl}`)
        .attr('alt', `vehicle-slideshow-${index}`);

      carouselItem.append(carouselImage);
      carouselInner.append(carouselItem);

      createModal(imageUrl, carouselItemId);

      if (index === 0) {
        carouselItem.addClass('active');
      }
    });
  }

  /**
   * To avoid having a huge amount of modals with all possible images in the twig
   * file and possibly increase loading times, this function will create a modal
   * with a src (image) and an id (imageId). Each time a new set of exterior
   * images are loaded (See function createSlides), a new modal is created for
   * each of those images to go with it.
   *
   * @param {string}        imageSource
   * @param {string}        imageId
   */
  function createModal(imageSource, imageId) {
    const modal = $('<div></div>')
      .addClass('modal fade')
      .attr('id', imageId)
      .attr('tabindex', '-1')
      .attr('role', 'dialog')
      .attr('aria-labelledby', 'ModalLabel')
      .attr('aria-hidden', 'true');
    const modalDialog = $('<div></div>').addClass('modal-dialog modal-xl').attr('role', 'document');
    const modalContent = $('<div></div>').addClass(
      'modal-content align-items-center justify-content-center d-flex bg-transparent border-0',
    );
    const closeButton = $('<button></button>')
      .addClass('align-self-end close m-5 p-2 bg-white')
      .attr('data-dismiss', 'modal')
      .attr('aria-label', 'Close');
    const closeIcon = $('<span>&times;</span>').attr('aria-hidden', 'true');
    const modalBody = $('<div></div>').addClass('modal-body');
    const modalImage = $('<img />')
      .addClass('carousel-item--image d-block w-100')
      .attr('src', imageSource)
      .attr('alt', 'Vehicle exterior');

    const closeButtonComplete = closeButton.append(closeIcon);
    const modalInner = modalBody.append(modalImage);
    const completeModal = modal.append(
      modalDialog.append(modalContent.append(closeButtonComplete, modalInner)),
    );

    carouselInner.append(completeModal);
  }

  /**
   * Takes in the status of the current user configuration and the
   * Configuration Token to create a button for the next step in the
   * B&P. If the current configuration requires user action, the button
   * will be disabled.
   *
   * @param {string}        status
   * @param {string}        configToken
   */
  function updateNextButton(configToken) {
    const href = `/showroom/summary/${styleId}?province_code=${provinceCode}&configuration_token=${configToken}`;

    if (isFullyConfigured) {
      bottomBarBtnNext
        .attr('href', href)
        .text('COMPLETE')
        .removeClass('disabled CustomDisabledButton');
      return;
    }

    bottomBarBtnNext
      .removeAttr('href')
      .attr('aria-disabled', 'true')
      .addClass('disabled CustomDisabledButton')
      .text('COMPLETE');
  }

  function updateColorizedImages(colorCode) {
    const selectedColourVehicle = colorizedImages[colorCode];
    const carouselImages = [];
    const allImages = { ...selectedColourVehicle, ...interiorImages };

    Object.keys(allImages)
      .sort()
      .forEach(function (key) {
        carouselImages.push(allImages[key].md.href);
      });
    eraseAllSlide();
    createSlides(carouselImages);
  }

  /**
   * Handles when a user selects an option
   * 1. Makes request to chromedata to check configuration
   * 2. Prompts user of any additional input required from them
   * 3. Updates image slider if option toggled is an exterior color (chromedata does not provide interior images)
   *
   * @param optionCode
   */
  function handleOptionSelection(optionCode) {
    if (!optionCode) {
      console.warn(oemLocalization.gettext('Option code is missing!'));
      return;
    }
    requestChromeData(configToken, optionCode);
  }

  updateNextButton(configToken);
  toggleLoadingScreen(false);

  $('.OptionsAccessoriesInput input').on('click', function () {
    // If input is type radio means one from its group must be selected
    // If already selected, no need to toogle value.
    // Also if is the only of the group, no need to toogle value.
    let inputType = this.getAttribute('type');
    let isChecked = this.classList.contains('checked');

    if (isChecked && inputType === 'radio') {
      return;
    }

    handleOptionSelection(this.getAttribute('data-option-code'));

    // Colors are configured using chrome_option_code
    // but colorized images use oem_option_code as the key
    if (
      this.dataset.exteriorColorCode &&
      colorizedImages.hasOwnProperty(this.dataset.exteriorColorCode)
    ) {
      updateColorizedImages(this.dataset.exteriorColorCode);
    }
  });

  $('#relatedTrims').on('change', function () {
    window.location.href = this.value;
  });

  $('.BottomBarBtnNext').on('click', function () {
    if ($('.CustomDisabledButton').length > 0) {
      dsp.alert({
        message: oemLocalization.gettext(
          'The vehicle is currently not fully configured. Please make sure you check off an item from each section.',
        ),
        icon: 'error',
      });
    }
  });

  function toggleDescription(description) {
    let closed = description.hasClass('text-truncate');

    description.find('.OptionReadMore').on('click', function () {
      description.toggleClass('text-truncate');
      closed = !closed;
      return closed
        ? $(this).text(oemLocalization.gettext('Read more'))
        : $(this).text(oemLocalization.gettext('Read less'));
    });
  }

  $('.OptionDescription').each(function () {
    toggleDescription($(this));
  });
}
